import { Grid, Paper, Typography } from "@mui/material"
import { Title } from "components/Common/Title"
import { TrainingReportParameterList } from "components/TrainingReportList/TrainingReportParameterList"
import { TrainingResultRadarChart } from "components/TrainingResult/TrainingResultRadarChart"
import { TrainingReportSuggestionList } from "components/TrainingResult/TrainingResultSuggestionList"
import { useAppSelector } from "hooks"
import { type ReactElement, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import trainingReportService from "services/trainingReportService"
import type { ILesson } from "types/lessonTypes"
import type { ITrainingReport, ITrainingReportParameter } from "types/trainingReportTypes"

const getPassedParameter = (parameter: ITrainingReportParameter | undefined): ReactElement => {
  const t = parameter?.value

  if (t === "Pass") {
    return (
      <Typography variant="h3" color={"#80ef80"} gutterBottom>
        Pass
      </Typography>
    )
  } else if (t === "Fail") {
    return (
      <Typography variant="h3" color={"red"} gutterBottom>
        Fail
      </Typography>
    )
  }

  return (
    <Typography variant="h3" color={"#80ef80"} gutterBottom>
      Completed
    </Typography>
  )
}

export function TrainingResult() {
  const [trainingReport, setTrainingReport] = useState<ITrainingReport>()
  const [lesson, setLesson] = useState<ILesson>()
  const lessons = useAppSelector((state) => state.lesson.lessons)
  const urlParams = useParams()

  useEffect(() => {
    trainingReportService
      .getUserTrainingReports(urlParams.userId ?? "")
      .then((reports) => {
        const report = reports.find((x) => x.id === urlParams?.reportId)
        setTrainingReport(report)
        setLesson(lessons.find((x) => x.id === report?.lessonId))
      })
      .catch((err) => {
        console.log(err)
      })
  }, [lessons.find, urlParams.userId, urlParams?.reportId])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Title>{lesson?.name.toUpperCase()}</Title>
          {trainingReport &&
            getPassedParameter(
              trainingReport.parameters.find((x) => {
                return x.name === "exam_result"
              }),
            )}

          {trainingReport && (
            <Typography variant="body2" color="text.primary">
              {" "}
              {new Date(trainingReport.endDate).toLocaleString()}
            </Typography>
          )}
        </Paper>
      </Grid>
      {trainingReport && trainingReport.parameters.length > 4 && (
        <Grid item xs={12}>
          <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
            <Title>USER PERFORMANCE CHART</Title>
            <TrainingResultRadarChart trainingReport={trainingReport} />
          </Paper>
        </Grid>
      )}
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Title>SUGGESTIONS</Title>
          {trainingReport && <TrainingReportSuggestionList trainingReport={trainingReport} />}
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Title>ALL TRAINING PARAMETERS</Title>
          {trainingReport && <TrainingReportParameterList parameters={trainingReport.parameters} />}
        </Paper>
      </Grid>
    </Grid>
  )
}
